import { Collapse, Form, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons } from '@/components/_common';
import { QuestWorkOrderTypesFilter } from '@/core/domain/questReport/Reports/CustomerWithoutMovement/CustomerWithoutMovement.types';
import { isAppPortocar } from '@/index';

export default function MoreOptions() {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const typeOptions = [
    {
      value: QuestWorkOrderTypesFilter.workOrder,
      label: intl({ id: 'CustomerWithoutMovement.option.budget' }),
    },
    {
      value: QuestWorkOrderTypesFilter.warranty,
      label: intl({ id: 'CustomerWithoutMovement.option.warranty' }),
    },
    {
      value: QuestWorkOrderTypesFilter.return,
      label: intl({ id: 'CustomerWithoutMovement.option.return' }),
    },
    {
      value: QuestWorkOrderTypesFilter.courtesy,
      label: intl({
        id: `CustomerWithoutMovement.option.${
          isAppPortocar ? 'insideCourtesy' : 'courtesy'
        }`,
      }),
    },
    {
      value: QuestWorkOrderTypesFilter.revision,
      label: intl({ id: 'CustomerWithoutMovement.option.revision' }),
    },
  ];
  return (
    <Collapse>
      <Collapse.Panel
        key={1}
        header={intl({ id: 'CustomerWithoutMovement.label.moreOptions' })}
      >
        <Form.Item
          name="workOrderTypesFilter"
          label={
            <Title level={5} style={{ margin: '0' }}>
              {intl({ id: 'CustomerWithoutMovement.label.type' })}
            </Title>
          }
          initialValue={[QuestWorkOrderTypesFilter.workOrder]}
        >
          <CheckboxGroupButtons options={typeOptions} />
        </Form.Item>
      </Collapse.Panel>
    </Collapse>
  );
}
